import * as React from "react";
import { Segment, Button, Form, TextArea, Header } from "semantic-ui-react";

type ApprovalBarProps = {
  approval: State.ApprovalState;
  isPushing: boolean;
  onApprove: () => void;
  onReject: (reason: string) => void;
};

type ApprovalBarState = {
  rejectionReason: string;
  showRejectForm: boolean;
};

class ApprovalBar extends React.Component<ApprovalBarProps, ApprovalBarState> {
  state: ApprovalBarState = {
    rejectionReason: "",
    showRejectForm: false,
  };

  private handleReasonChange = (_e: React.FormEvent, data: any): void => {
    this.setState({ rejectionReason: data.value });
  };

  private handleReject = (): void => {
    this.props.onReject(this.state.rejectionReason);
    this.setState({ rejectionReason: "", showRejectForm: false });
  };

  private toggleRejectForm = (): void => {
    this.setState((prev) => ({ showRejectForm: !prev.showRejectForm }));
  };

  render(): JSX.Element {
    const { approval, isPushing, onApprove } = this.props;
    const { rejectionReason, showRejectForm } = this.state;

    if (approval.status !== "pending") {
      return <></>;
    }

    return (
      <Segment>
        <Header as="h4">LOTA Approval Required</Header>
        <p>
          Requested by: <strong>{approval.requestedBy}</strong>
          {approval.requestedAt && (
            <> at {new Date(approval.requestedAt).toLocaleString()}</>
          )}
        </p>
        {approval.comment && <p>Comment: {approval.comment}</p>}

        <Button.Group fluid>
          <Button
            positive
            loading={isPushing}
            disabled={isPushing}
            onClick={onApprove}
          >
            Approve
          </Button>
          <Button.Or />
          <Button
            negative
            loading={isPushing}
            disabled={isPushing}
            onClick={this.toggleRejectForm}
          >
            Reject
          </Button>
        </Button.Group>

        {showRejectForm && (
          <Form style={{ marginTop: "1em" }}>
            <Form.Field>
              <label>Rejection reason</label>
              <TextArea
                placeholder="Provide a reason for rejection..."
                value={rejectionReason}
                onChange={this.handleReasonChange}
              />
            </Form.Field>
            <Button
              negative
              fluid
              loading={isPushing}
              disabled={isPushing || !rejectionReason.trim()}
              onClick={this.handleReject}
            >
              Confirm Rejection
            </Button>
          </Form>
        )}
      </Segment>
    );
  }
}

export default ApprovalBar;
